import InputsSelectionProcess from '../InputsSelectionProcess'
import { SelectedColumnsProvider } from '../SelectedColumnsProvider'
import SelectedFilesProvider from '../selectedFilesProvider'

export default function StartScanScreen(): JSX.Element {
  return (
    <div>
      <SelectedFilesProvider>
        <SelectedColumnsProvider>
          <InputsSelectionProcess />
        </SelectedColumnsProvider>
      </SelectedFilesProvider>
    </div>
  )
}
